export default {
  tradeInfo: {
    news: {
      eyebrow: 'Latest Updates',
      title: 'Industry News',
    },
    resources: {
      eyebrow: 'Knowledge Base',
      title: 'Trade Resources',
    },
    newsItems: [
      { date: 'Dec 2024', title: 'Japanese Chemical Industry Outlook 2025', description: 'Analysis of market trends and growth projections for the Japanese chemical sector in the coming year.', category: 'Market Analysis' },
      { date: 'Nov 2024', title: 'New Export Regulations Update', description: 'Important updates to chemical export regulations affecting international trade from Japan.', category: 'Regulations' },
      { date: 'Oct 2024', title: 'Rare Earth Supply Chain Developments', description: 'Latest developments in rare earth element supply chains and their impact on global markets.', category: 'Supply Chain' },
      { date: 'Sep 2024', title: 'Sustainability in Chemical Manufacturing', description: 'How Japanese manufacturers are leading the way in sustainable chemical production practices.', category: 'Sustainability' },
    ],
    resourceItems: [
      { icon: 'ri-file-chart-line', title: 'Market Reports', description: 'Comprehensive analysis of chemical market trends and forecasts' },
      { icon: 'ri-government-line', title: 'Regulatory Updates', description: 'Latest changes in chemical trade regulations and compliance requirements' },
      { icon: 'ri-truck-line', title: 'Logistics Insights', description: 'Information on shipping, customs, and international logistics' },
      { icon: 'ri-lightbulb-line', title: 'Industry Innovations', description: 'New developments and technologies in the chemical industry' },
    ],
    cta: {
      title: 'Need More Information?',
      description: 'Contact our team for detailed market insights and trade consultation.',
      btn: 'Contact Us',
    },
  },
};
